<template>
  <div>
    <!-- ================= REDE / SUBREDE ================= -->
    <div class="q-pb-md">

      <!-- Título -->
      <div class="row items-center q-pb-xs">
        <div class="row items-center">
          <span class="midia-app-caption-sm q-pr-sm">
            Rede / Subrede * 
          </span>

          <q-btn
            outline dense size="sm"
            color="negative"
            label="Limpar"
            no-caps
            class="btn-inline-action q-mr-xs"
            @click="onClearRedeSubrede"
          />

          <q-btn
            outline dense size="sm"
            color="negative"
            label="Excluir"
            no-caps
            class="btn-inline-action"
            @click="onClearRedeSubrede"
          />

        </div>
      </div>

      <!-- Input -->
      <div class="row items-center no-wrap">
        <div class="col">
          <q-input
            :model-value="redeSubredeStore.labelSelecionadas"
            outlined
            dense
            readonly
            placeholder="Selecione uma ou mais Subredes"
          >
            <template #append>
              <q-icon name="keyboard_arrow_down" size="18px" />
            </template>
          </q-input>
        </div>

        <q-btn
          outline
          dense
          size="sm"
          color="negative"
          label="Filtrar"
          no-caps
          class="btn-filter-equal-height q-ml-sm"
          @click="showNetworkSubnetModal = true"
        />
      </div>

    </div>

    <!-- ================= PCs ================= -->
    <div class="q-pb-md">

      <!-- Título -->
      <div class="row items-center q-pb-xs">
        <div class="row items-center">
          <span class="midia-app-caption-sm q-pr-sm">
            PCs 
          </span>

          <q-btn
            outline
            dense
            size="sm"
            color="negative"
            label="Limpar"
            no-caps
            class="btn-inline-action q-mr-xs"
            @click="onClearPCs"
          />

          <q-btn
            outline
            dense
            size="sm"
            color="negative"
            label="Excluir"
            no-caps
            class="btn-inline-action"
            @click="onClearPCs"
          />
        </div>
      </div>

      <!-- Input -->
      <div class="row items-center no-wrap">
        <div class="col">
          <q-input
            :model-value="pcLabelSelecionados"
            outlined
            dense
            readonly
            placeholder="Selecione um ou mais PCs"
          >
            <template #append>
              <q-icon name="keyboard_arrow_down" size="18px" />
            </template>
          </q-input>
        </div>

        <q-btn
          outline
          dense
          size="sm"
          color="negative"
          label="Filtrar"
          no-caps
          class="btn-filter-equal-height q-ml-sm"
          @click="showPCsModal = true"
        />
      </div>

      <!-- ✅ CHIPS (IGUAL SUBREDE) -->
      <div class="q-mt-sm row q-gutter-sm">
        <q-chip
          v-for="pc in pcStore.selectedPCs"
          :key="pc.codpontocaptura"
          removable
          @remove="removePC(pc)"
        >
          {{ pc.codpontocaptura }} - {{ pc.nompontocaptura }}
        </q-chip>
      </div>

    </div>

    <!-- ================= MODAIS ================= -->
    <InstitutionalFilterNetworkSubnetModal
      v-model="showNetworkSubnetModal"
    />

    <ModalFilterPcsInstitutional
      v-model="showPCsModal"
    />

    <ModalPCsInstitutional />

  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted} from 'vue'

import InstitutionalFilterNetworkSubnetModal from '@/views/layout/modalsInstitutional/InstitutionalFilterNetworkSubnetModal.vue'
import ModalFilterPcsInstitutional from '@/views/layout/modalsInstitutional/ModalFilterPcsInstitutional.vue'
import ModalPCsInstitutional from '@/views/layout/modalsInstitutional/ModalPCsInstitutional.vue'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { useRedeSubredeStore } from '@/stores/redeSubredeStore'
import { usePCStore } from '@/stores/pcStore'

const institutionalStore = useInstitutionalStore()
const redeSubredeStore = useRedeSubredeStore()
const pcStore = usePCStore()

const showNetworkSubnetModal = ref(false)
const showPCsModal = ref(false)

/* =======================
 * REDE
 * ======================= */
const onClearRedeSubrede = () => {
  redeSubredeStore.limpar()
}

/* =======================
 * PCs
 * ======================= */
const pcLabelSelecionados = computed(() =>
  pcStore.selectedPCs.length
    ? `${pcStore.selectedPCs.length} selecionado(s)`
    : ''
)

const onClearPCs = () => {
  pcStore.setSelectedPCs([])
}

const removePC = (pcToRemove: any) => {
  pcStore.setSelectedPCs(
    pcStore.selectedPCs.filter(
      pc => pc.codpontocaptura !== pcToRemove.codpontocaptura
    )
  )
}

onMounted(async () => {
  const detail = institutionalStore.institutionalDetail
  if (!detail) return

  // ✅ Sincroniza subredes
  if (detail.redes?.length) {
    await redeSubredeStore.setSelecionadasFromBackend(detail.redes)
  }

  // ✅ Sincroniza PCs — usa detail.pcs que tem os dados completos
  if (detail.pcs?.length) {
    pcStore.setSelectedPCs(detail.pcs)
  }
  // ⚠️ fallback pcsIds: só tem o ID, sem nome — evite se possível
  // Use apenas se o backend não retornar detail.pcs populado
})


</script>

<style scoped>
.btn-inline-action {
  padding: 0 8px;
  min-height: 24px;
}

.btn-filter-equal-height {
  min-height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
}
</style>